import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTriangleLang = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 6,
	viewBox: "0 0 8 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4 6L0.535899 -6.52533e-07L7.4641 -4.68497e-08L4 6Z",
		fill: "#69A2E4"
	})]
});
const ForwardRef = forwardRef(SvgTriangleLang);
export { ForwardRef as ReactComponent };
